const initialStates = {
    msg: {
        content: '',
        type: 'danger',
        showIn: false
    },
}

const mutations = {
    set(state, msg) {
        state.msg = Object.assign({}, state.msg, msg)
    },
    reset(state) {
        state.msg = {
            content: '',
            type: 'danger'
        }
    }
}

const getters = {
    msg: state => state.msg
}

const actions = {
    setMsg({commit}, msg) {
        commit('set', msg)
    },
    resetMsg({commit}) {
        commit('reset')
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}